import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { AcademicComponent } from './pages/academic/academic.component';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HeaderComponent } from './pages/header/header.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { ContactComponent } from './pages/contact/contact.component';
import { PubDisclosureComponent } from './pages/pub-disclosure/pub-disclosure.component';
import { NewsComponent } from './pages/news/news.component';
import { FooterComponent } from './pages/footer/footer.component';
import { HomeFaqComponent } from './pages/home/home-faq/home-faq.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { DirectorMsgComponent } from './pages/about-us/director-msg/director-msg.component';
import {MatDividerModule} from '@angular/material/divider';
import { MatSelectModule } from "@angular/material/select";
import {MatTabsModule} from '@angular/material/tabs';
import { CurriculamComponent } from './pages/curriculam/curriculam.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTableModule} from '@angular/material/table';
import { DressesComponent } from './pages/dresses/dresses.component';
import { FeesComponent } from './pages/fees/fees.component';
import { HttpClientModule } from '@angular/common/http';
import { SchGuidelinesComponent } from './pages/sch-guidelines/sch-guidelines.component';
import { EnquiryDialogComponent } from './pages/home/enquiry-dialog/enquiry-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AnnouncementOverlayComponent } from './pages/announcement-overlay/announcement-overlay.component';
import { MatOptionModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { ViewNewsComponent } from './pages/news/view-news/view-news.component';
import { SchoolMapService } from './shared/services/school-map.service';
import { FacilitiesComponent } from './pages/facilities/facilities.component';
import { ThemeService } from './shared/services/theme.service';
import { PeopleBehindVisionComponent } from './shared/components/people-behind-vision/people-behind-vision.component';
import { ContactUsComponent } from './shared/components/contact-us/contact-us.component';
import { UtilFileViewerComponent } from './shared/components/util-file-viewer/util-file-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Header2Component } from './pages/header2/header2.component';
import { Carousel1Component } from './pages/features/carousel1/carousel1.component';
import { Carousel2Component } from './pages/features/carousel2/carousel2.component';
import { AdmissionUpdateComponent } from './pages/home/admission-update/admission-update.component';
import { GalleryViewerComponent } from './pages/gallery/gallery-viewer/gallery-viewer.component';
import { ImageShowcaseComponent } from './pages/image-showcase/image-showcase.component';
import { NewsNoticeOverlayV2Component } from './pages/home/news-notice-overlay-v2/news-notice-overlay-v2.component';
import { AchievementsComponent } from './pages/home/achievements/achievements.component';
import { AboutUsV2Component } from './pages/about-us/about-us-v2/about-us-v2.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        AboutUsComponent,
        AcademicComponent,
        HeaderComponent,
        Header2Component,
        GalleryComponent,
        ContactComponent,
        PubDisclosureComponent,
        NewsComponent,
        FooterComponent,
        HomeFaqComponent,
        DirectorMsgComponent,
        CurriculamComponent,
        DressesComponent,
        FeesComponent,
        SchGuidelinesComponent,
        EnquiryDialogComponent,
        AnnouncementOverlayComponent,
        ViewNewsComponent,
        FacilitiesComponent,
        PeopleBehindVisionComponent,
        ContactUsComponent,
        UtilFileViewerComponent,
        Carousel1Component,
        Carousel2Component,
        AdmissionUpdateComponent,
        GalleryViewerComponent,
        ImageShowcaseComponent,
        NewsNoticeOverlayV2Component,
        AchievementsComponent,
        AboutUsV2Component
       
        
    ],
    providers: [
        {
        provide: APP_INITIALIZER,
        useFactory: appInitializer,
        deps: [SchoolMapService, ThemeService],
        multi: true
        }
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        MatSelectModule,
        MatTabsModule,
        MatButtonToggleModule,
        MatTableModule,
        HttpClientModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        FormsModule,
        MatSnackBarModule,
        MatOptionModule,
        MatRadioModule,
        MatListModule,
        // NoopAnimationsModule
        PdfViewerModule
    ]
})
export class AppModule { }

export function appInitializer(
  schoolMap: SchoolMapService,
  themeService: ThemeService
) {
  return async () => {
    await schoolMap.load();
    await themeService.load();
  };
}
